export enum PlaceAndStreetControlName {
  MapObjectsArray = 'mapObjectsArray',
  Uuid = 'uuid',
  Place = 'place',
  SelectedPlace = 'selectedPlace',
  StreetsOptions = 'streetsOptions',
  Street = 'street',
}
